"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSavedPaymentAddress = void 0;
/*
Copyright (C) 2009 - 2021 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
const react_1 = require("react");
const lodash_1 = require("lodash");
const payment_js_1 = require("@broadleaf/payment-js");
const use_is_saved_address_1 = require("../use-is-saved-address");
/**
 * This hook can be used to help set up a billing address form state including fetching the
 * customer's saved address (if authenticated) and managing the address state.
 */
const useSavedPaymentAddress = (props) => {
    const { currentBillingAddress, authState, addresses, defaultUserAddress, isFetching } = props;
    const { isAuthenticating, isAuthenticated } = authState;
    const loadingAddresses = isFetching;
    const savedAddresses = addresses;
    const [selectedAddress, setSelectedAddress] = (0, react_1.useState)(defaultUserAddress);
    const usingSavedAddress = (0, use_is_saved_address_1.useIsSavedAddress)({
        savedAddresses,
        selectedAddress
    });
    (0, react_1.useEffect)(() => {
        if (isAuthenticating || !isAuthenticated || loadingAddresses) {
            return;
        }
        if (!(0, lodash_1.isEmpty)(defaultUserAddress)) {
            setSelectedAddress(defaultUserAddress);
            return;
        }
    }, [defaultUserAddress, isAuthenticating, isAuthenticated, loadingAddresses]);
    return (0, react_1.useMemo)(() => {
        let currentSavedAddresses = savedAddresses;
        if (currentBillingAddress) {
            const originalAddress = Object.assign({ id: 'ORIGINAL' }, currentBillingAddress);
            if (savedAddresses) {
                const isSavedAddress = !!(0, payment_js_1.findMatchingSavedAddress)(savedAddresses, currentBillingAddress);
                currentSavedAddresses = isSavedAddress
                    ? currentSavedAddresses
                    : currentSavedAddresses.concat([originalAddress]);
            }
            else {
                currentSavedAddresses = [originalAddress];
            }
        }
        return {
            savedAddresses: currentSavedAddresses,
            selectedAddress,
            setSelectedAddress,
            usingSavedAddress
        };
    }, [
        savedAddresses,
        selectedAddress,
        usingSavedAddress,
        currentBillingAddress
    ]);
};
exports.useSavedPaymentAddress = useSavedPaymentAddress;
//# sourceMappingURL=use-saved-payments-address.js.map